import {TotalsData} from "../../../recebiveis/types";
import {formatTakeRate, formatTotal} from "../../../../../utils/generalFormat";
import {ValueCard} from "../../../recebiveis/styles";

export const Totals: React.FC<{data: TotalsData}> = ({data}) => {
  return (
    <>
      <ValueCard>
        <div>
          <p>Valor das Vendas:</p>
          <p>{formatTotal(data.totalValue)}</p>
        </div>

        <div>
          <p>Valor Líquido:</p>
          <p>{formatTotal(data.totalLiquidValue)}</p>
        </div>

        <div>
          <p>Custo Total MDR:</p>
          <p>{formatTotal(data.totalMdrValue)}</p>
        </div>

        <div>
          <p>Custo Antecipação:</p>
          <p>{formatTotal(data.totalAnticipation)}</p>
        </div>

        <div>
          <p>Custo Total:</p>
          <p>{formatTotal(data.totalCost)}</p>
        </div>

        <div>
          <p>Recebido Acquirer:</p>
          <p>{formatTotal(data.totalAcquirer)}</p>
        </div>

        <div>
          <p>Receita:</p>
          <p>{formatTotal(data.totalRevenue)}</p>
        </div>

        <div>
          <p>Take Rate:</p>
          <p>{formatTakeRate(data.takeRate)}</p>
        </div>
      </ValueCard>
    </>
  )
}
